import { autoinject, transient } from "aurelia-dependency-injection";
import { RightShipDialogServiceConstants } from "../../../../../../../../constants/basics/rightship-dialog.constants";
import { EntityTypes } from "@rightship-tech/common-ui/models/basic.models";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { VettingService } from "../../../../../../../../services/vetting/vetting.service";
import { BaseRedMarblePlugin } from "./base-red-marble";
import { Reflection } from "../../../../../../../../utilities/reflection";
import { computedFrom } from "aurelia-binding";

@autoinject
@transient()
export class Mgmt extends BaseRedMarblePlugin {

    constructor(private dialogClientService: DialogClientService,
        private vetService: VettingService) {
        super();
    }

    @computedFrom(Reflection.getPropertyPath<Mgmt>(z => z.rsData))
    get current() {
        const result = {};
        if (this.rsData) {
            for (const d of this.rsData) {
                result[d.role] = d;
            }
        }
        return result;
    }

    @computedFrom(Reflection.getPropertyPath<Mgmt>(z => z.data),
        Reflection.getPropertyPath<Mgmt>(z => z.data.data),
        Reflection.getPropertyPath<Mgmt>(z => z.data.data.EquasisVesselManagementDetails),
        Reflection.getPropertyPath<Mgmt>(z => z.data.data.EquasisVesselManagementDetails.length),
        Reflection.getPropertyPath<Mgmt>(z => z.data.data.IhsVesselManagementDetails),
        Reflection.getPropertyPath<Mgmt>(z => z.data.data.IhsVesselManagementDetails.length))
    get other() {
        let data: any[] = this.data && this.data.data && this.data.data.EquasisVesselManagementDetails
            ? this.data.data.EquasisVesselManagementDetails : [];

        const ihs: any[] = this.data && this.data.data && this.data.data.IhsVesselManagementDetails
            ? this.data.data.IhsVesselManagementDetails : [];

        data = data.concat(ihs);

        for (const x of data) {
            if (x.role.toLowerCase() == "ism manager")
                x.role = "Document of Compliance";
            else if (x.role.toLowerCase() == "ship manager/commercial manager")
                x.role = "Commercial Manager";
            else if (x.role.toLowerCase() == "commercial operator")
                x.role = "Commercial Operator";
            else if (x.role.toLowerCase() == "beneficial owner")
                x.role = "Beneficial Owner";
            else if (x.role.toLowerCase() == "registered owner")
                x.role = "Registered Owner";
            else if (x.role.toLowerCase() == "technical manager")
                x.role = "Technical Manager";
        }

        return data;
    }


    toggleEditDialog(role: string, name: string) {
        let property = "";

        if (role == "Document of Compliance")
            property = "DocumentOfComplianceCompanyId";
        else if (role == "Commercial Manager")
            property = "CommercialManagerCompanyId";
        else if (role == "Commercial Operator")
            property = "CommericalOwnerCompanyId";
        else if (role == "Beneficial Owner")
            property = "BeneficialOwnerCompanyId";
        else if (role == "Registered Owner")
            property = "RegisteredOwnerCompanyId";
        else if (role == "Technical Manager")
            property = "TechnicalManagerCompanyId";

        if (!property) return;

        this.dialogClientService.show(RightShipDialogServiceConstants.URLs.EditableEntityPropertyDialog, {
            filter: name,
            entity: this.getEntityPayload(role),
            properties: [property],
            refresh: (() => {
                this.vetService.getVetTasks(this.vet.vetId).then(x => {
                    this.vet.vetTasks = x;
                });
            }).bind(this)
        }, true, false, false, "right");
    }

    getEntityPayload(role: any) {
        const currentValue = this.current[role].companyName;
        const entity: any = {
            entityType: EntityTypes.Vessel,
            vesselId: this.vet.vesselId,
            id: this.vet.vesselId
        }
        if (role == "Document of Compliance")
            entity.documentOfComplianceCompany = currentValue;
        else if (role == "Commercial Manager")
            entity.commercialManagerCompany = currentValue;
        else if (role == "Commercial Operator")
            entity.commericalOwnerCompany = currentValue;
        else if (role == "Beneficial Owner")
            entity.beneficialOwnerCompany = currentValue;
        else if (role == "Registered Owner")
            entity.registeredOwnerCompany = currentValue;
        else if (role == "Technical Manager")
            entity.technicalManagerCompany = currentValue;
        else {
            //do nothing
        }
        return entity;
    }

}